<template>
    <div
      style=""
      class="pt-5 px-5 center"
    >
      <h1 class="mb-4">Thank you (:</h1>
      <h3 class="mb-1">We are so excited to meet you!</h3>
        <!-- <h3 class="mb-5">We have received your submission and will be in touch with you soon.</h3> -->
      <img
              src="../assets/img/home/AdobeStock_601259139.jpg"
              width="80%"
              height=""
              class="mt-4 mb-5"
              style="max-width: 500px;"
            />
    </div>
  </template>

<script>
export default {
  created() {
    // this.$store.dispatch('tryAutoLogin')
    // Scroll the window up
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },
};
</script>


// WEBPACK FOOTER //
// src/components/ThankYou2.vue